import ConstantesTabla from "../../utils/ConstantesTabla";
import DataTable from "react-data-table-component";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./concursoPS.scss";

import { Link } from "react-router-dom";

const ConsModSolicitudesF = (object) => {
  const navigate = useNavigate();
  const anexos = [
    {
      id: 1,
      nombre: "Anexo II.1 (Solicitud de participación)",
    },
    {
      id: 2,
      nombre: (
        <>
          <p className="mt-2">Anexo II.2 (Peticiones de destino)</p>
          <div className="d-flex flex-column">
            <i className="fa-solid fa-caret-right my-2">
              {" "}
              <Link 
              to={`/seleccionPuestos/${object.codConcurso}/${object.xSolicitud}`} 
              state={{adscripcion:"F",tipoConvocatoria:object.tipoConvocatoria}} 
              className="fw-light"
              role="link"
              title="Anexo II.2"
              aria-label="Anexo II.2"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault()
                  navigate(`/seleccionPuestos/${object.codConcurso}/${object.xSolicitud}`)
                }
              }}
              >
                Grabación de puestos
              </Link>
            </i>
            <i className="fa-solid fa-caret-right my-2">
              {" "}
              <Link to={`/puestosOrdenPreferencia/${object.codConcurso}/${object.xSolicitud}`} 
              className="fw-light"
              role="link"
              title="Anexo II.2"
              aria-label="Anexo II.2"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  navigate(`/puestosOrdenPreferencia/${object.codConcurso}/${object.xSolicitud}`)
                }
              }}
              >
                Visualización de puestos seleccionados y reordenar preferencias
              </Link>
            </i>
          </div>
        </>
      ),
    },
    {
      id: 3,
      nombre: "Anexo II.3 (Alegación de requisitos específicos)",
    },
    {
      id: 4,
      nombre: "Anexo II.4 (Alegaciones de méritos)",
    },
  ];
  const columnas = [ConstantesTabla.columnasTablaAnexos];
  columnas.push({
    name: "Modificar",
    grow: 1.1,
    center: true,
    cell: (row) =>
      row.id === 1 ? (
        <i
          className="fa-solid fa-file-pen fs-3 mx-2 px-3 cursorPointer faHover"
          onClick={() => navigate(`/anexoii_1/${object.codConcurso}/${object.xSolicitud}`)}
          role="button"
              title="Anexo II.1"
              aria-label="Anexo II.1"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault()
                  navigate(`/anexoii_1/${object.codConcurso}/${object.xSolicitud}`)
                }
              }}
        ></i>
      ) : row.id === 3 ? (
        <i
          className="fa-solid fa-file-pen fs-3 mx-2 px-3 cursorPointer faHover"
          onClick={() => navigate(`/anexoii_3/${object.codConcurso}/${object.xSolicitud}`, {state:{numSol:object.numSol}})}
          role="button"
          title="Anexo II.3"
          aria-label="Anexo II.3"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault()
              navigate(`/anexoii_3/${object.codConcurso}/${object.xSolicitud}`)
            }
          }}
        ></i>
      ) : row.id === 4 ? (
        <i
          className="fa-solid fa-file-pen fs-3 mx-2 px-3 cursorPointer faHover"
          onClick={() => navigate(`/anexoii_4/${object.codConcurso}/${object.xSolicitud}`,{state:{numSol:object.numSol}})}
          role="button"
          title="Anexo II.4"
          aria-label="Anexo II.4"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault()
              navigate(`/anexoii_4/${object.codConcurso}/${object.xSolicitud}`)
            }
          }}
        ></i>
      ) : null,
  });
  useEffect(() => {}, []);
  return (
    <>
      <DataTable
        // title = "Anexos modificación"
        aria-label = "Tabla con los diferentes anexos para la modificación de la solicitud de concursos"
        className="table-responsive"
        columns={columnas}
        data={anexos}
        pagination
        paginationComponentOptions={ConstantesTabla.paginacionOpt}
        noDataComponent={<span>No se encontró ninguna solicitud</span>}
        customStyles={ConstantesTabla.customStyles}
        fixedHeader
        fixedHeaderScrollHeight="600px"
        style={{ marginTop: "20px" }}
      />
    </>
  );
};

export default ConsModSolicitudesF;
